import { gsap } from "gsap/all";

export class Marquee {
  constructor(element) {
    this.element = element;
    this.items = [...element.querySelectorAll(`.js-marquee-item`)];
    this.init();
  }

  createTimeline = () => {
    this.timeline = gsap.timeline({ repeat: -1 });
    this.timeline.to(this.items, 20, {
      x: "-100%",
      ease: "none",
    });
  };

  init() {
    this.createTimeline();
  }
}
